// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page */

body {
    margin: 0;
    background-color: #f4f6f8;
    font-family: Arial, Helvetica, sans-serif;
}

/* Title */

.Title {
    text-align: center;
    margin: 30px 0;
}

.Title h1 {
    color: #2c3e50;
    font-size: 2.5rem;
    margin: 0;
}

/* Game List Container */

.GameList {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
}

/* Individual Game */

.game {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    display: block;

    box-shadow:
        0 2px 6px rgba(0, 0, 0, 0.08),
        0 6px 18px rgba(0, 0, 0, 0.05);

    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
}

.game:hover {
    transform: translateY(-2px);

    box-shadow:
        0 6px 14px rgba(0, 0, 0, 0.12),
        0 10px 24px rgba(0, 0, 0, 0.08);
}

/* Text */

.game p {
    margin: 8px 0;
    color: #34495e;
}

.game b {
    color: #2c3e50;
}

/* Settings Section */

.game .settings-title {
    margin-top: 15px;
    font-size: 1.05rem;
    border-top: 1px solid #e4e7eb;
    padding-top: 10px;
}

.indented {
    text-indent: 25px;
}

.game p {
    display: block;
    margin: 8px 0;
}

details {
    margin-top: 10px;
}

summary {
    cursor: pointer;
    font-weight: bold;
    color: #2c3e50;
}

summary:hover {
    color: #3498db;
}

.game {
    background: white;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 50%;
    justify-self: center;
}

.game-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.game-info {
    display: flex;
    flex-direction: column;
}

.game-info p {
    margin: 4px 0;
}

.join-btn {
    background-color: #2ecc71;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s;

}

.join-btn:hover {
    background-color: #27ae60;
}

.createGameButton {
    display: block;

    margin: 20px auto;
    padding: 12px 24px;

    background-color: #4CAF50;
    color: white;

    border: none;
    border-radius: 8px;

    font-size: 18px;
    font-weight: bold;

    cursor: pointer;
    transition: all 0.2s ease;
}

body {
    margin: 0;
    background-color: #f4f6f8;
    font-family: Arial, Helvetica, sans-serif;
}

/* Title */

.Title {
    text-align: center;
    margin: 30px 0;
}

.Title h1 {
    color: #2c3e50;
    font-size: 2.5rem;
    margin: 0;
}

/* Game List Container */

.GameList {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
}

/* Individual Game */

.game {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    display: block;

    box-shadow:
        0 2px 6px rgba(0, 0, 0, 0.08),
        0 6px 18px rgba(0, 0, 0, 0.05);

    transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;
}

.game:hover {
    transform: translateY(-2px);

    box-shadow:
        0 6px 14px rgba(0, 0, 0, 0.12),
        0 10px 24px rgba(0, 0, 0, 0.08);
}

/* Text */

.game p {
    margin: 8px 0;
    color: #34495e;
}

.game b {
    color: #2c3e50;
}

/* Settings Section */

.game .settings-title {
    margin-top: 15px;
    font-size: 1.05rem;
    border-top: 1px solid #e4e7eb;
    padding-top: 10px;
}

.indented {
    text-indent: 25px;
}

.game p {
    display: block;
    margin: 8px 0;
}

details {
    margin-top: 10px;
}

summary {
    cursor: pointer;
    font-weight: bold;
    color: #2c3e50;
}

summary:hover {
    color: #3498db;
}

.game {
    background: white;
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    width: 50%;
    justify-self: center;
}

.game-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.game-info {
    display: flex;
    flex-direction: column;
}

.game-info p {
    margin: 4px 0;
}

.join-btn {
    background-color: #2ecc71;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s;

}

.join-btn:hover {
    background-color: #27ae60;
}

.createGameButton {
    display: block;

    margin: 20px auto;
    padding: 12px 24px;

    background-color: #4CAF50;
    color: white;

    border: none;
    border-radius: 8px;

    font-size: 18px;
    font-weight: bold;

    cursor: pointer;
    transition: all 0.2s ease;
}
.anagramsCGB {
    background-color: #1A78A3;
}
.anagramsCGB:hover {
    background-color: #16698e;
}
    
.connfourCGB {
    background-color: #526236;
}

.connfourCGB:hover {
    background-color: #227a16;
}

.createGameButton:hover {

    transform: translateY(-2px);
}

.createGameButton:active {
    transform: translateY(0);
}

/* Responsive */

@media (max-width: 768px) {
    .Title h1 {
        font-size: 2rem;
    }

    .game {
        padding: 15px;
    }
};



.createGameButton:active {
    transform: translateY(0);
}

/* Responsive */

@media (max-width: 768px) {
    .Title h1 {
        font-size: 2rem;
    }

    .game {
        padding: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/Lobbies.css"],"names":[],"mappings":"AAAA,SAAS;;AAET;IACI,SAAS;IACT,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA,UAAU;;AAEV;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA,wBAAwB;;AAExB;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB;;AAEpB;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;;IAEd;;sCAEkC;;IAElC;;4BAEwB;AAC5B;;AAEA;IACI,2BAA2B;;IAE3B;;uCAEmC;AACvC;;AAEA,SAAS;;AAET;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;;AAErB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;;AAErC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;;IAEd,iBAAiB;IACjB,kBAAkB;;IAElB,yBAAyB;IACzB,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA,UAAU;;AAEV;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;AAEA,wBAAwB;;AAExB;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB;;AAEA,oBAAoB;;AAEpB;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;;IAEd;;sCAEkC;;IAElC;;4BAEwB;AAC5B;;AAEA;IACI,2BAA2B;;IAE3B;;uCAEmC;AACvC;;AAEA,SAAS;;AAET;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;;AAErB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,wCAAwC;IACxC,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;;AAErC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;;IAEd,iBAAiB;IACjB,kBAAkB;;IAElB,yBAAyB;IACzB,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,eAAe;;AAEf;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ;;;;AAIA;IACI,wBAAwB;AAC5B;;AAEA,eAAe;;AAEf;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Page */\n\nbody {\n    margin: 0;\n    background-color: #f4f6f8;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n/* Title */\n\n.Title {\n    text-align: center;\n    margin: 30px 0;\n}\n\n.Title h1 {\n    color: #2c3e50;\n    font-size: 2.5rem;\n    margin: 0;\n}\n\n/* Game List Container */\n\n.GameList {\n    width: 90%;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* Individual Game */\n\n.game {\n    background-color: white;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 20px;\n    display: block;\n\n    box-shadow:\n        0 2px 6px rgba(0, 0, 0, 0.08),\n        0 6px 18px rgba(0, 0, 0, 0.05);\n\n    transition:\n        transform 0.2s ease,\n        box-shadow 0.2s ease;\n}\n\n.game:hover {\n    transform: translateY(-2px);\n\n    box-shadow:\n        0 6px 14px rgba(0, 0, 0, 0.12),\n        0 10px 24px rgba(0, 0, 0, 0.08);\n}\n\n/* Text */\n\n.game p {\n    margin: 8px 0;\n    color: #34495e;\n}\n\n.game b {\n    color: #2c3e50;\n}\n\n/* Settings Section */\n\n.game .settings-title {\n    margin-top: 15px;\n    font-size: 1.05rem;\n    border-top: 1px solid #e4e7eb;\n    padding-top: 10px;\n}\n\n.indented {\n    text-indent: 25px;\n}\n\n.game p {\n    display: block;\n    margin: 8px 0;\n}\n\ndetails {\n    margin-top: 10px;\n}\n\nsummary {\n    cursor: pointer;\n    font-weight: bold;\n    color: #2c3e50;\n}\n\nsummary:hover {\n    color: #3498db;\n}\n\n.game {\n    background: white;\n    padding: 20px;\n    border-radius: 12px;\n    margin-bottom: 20px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    width: 50%;\n    justify-self: center;\n}\n\n.game-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.game-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.game-info p {\n    margin: 4px 0;\n}\n\n.join-btn {\n    background-color: #2ecc71;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: background-color 0.2s;\n\n}\n\n.join-btn:hover {\n    background-color: #27ae60;\n}\n\n.createGameButton {\n    display: block;\n\n    margin: 20px auto;\n    padding: 12px 24px;\n\n    background-color: #4CAF50;\n    color: white;\n\n    border: none;\n    border-radius: 8px;\n\n    font-size: 18px;\n    font-weight: bold;\n\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\nbody {\n    margin: 0;\n    background-color: #f4f6f8;\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n/* Title */\n\n.Title {\n    text-align: center;\n    margin: 30px 0;\n}\n\n.Title h1 {\n    color: #2c3e50;\n    font-size: 2.5rem;\n    margin: 0;\n}\n\n/* Game List Container */\n\n.GameList {\n    width: 90%;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* Individual Game */\n\n.game {\n    background-color: white;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 20px;\n    display: block;\n\n    box-shadow:\n        0 2px 6px rgba(0, 0, 0, 0.08),\n        0 6px 18px rgba(0, 0, 0, 0.05);\n\n    transition:\n        transform 0.2s ease,\n        box-shadow 0.2s ease;\n}\n\n.game:hover {\n    transform: translateY(-2px);\n\n    box-shadow:\n        0 6px 14px rgba(0, 0, 0, 0.12),\n        0 10px 24px rgba(0, 0, 0, 0.08);\n}\n\n/* Text */\n\n.game p {\n    margin: 8px 0;\n    color: #34495e;\n}\n\n.game b {\n    color: #2c3e50;\n}\n\n/* Settings Section */\n\n.game .settings-title {\n    margin-top: 15px;\n    font-size: 1.05rem;\n    border-top: 1px solid #e4e7eb;\n    padding-top: 10px;\n}\n\n.indented {\n    text-indent: 25px;\n}\n\n.game p {\n    display: block;\n    margin: 8px 0;\n}\n\ndetails {\n    margin-top: 10px;\n}\n\nsummary {\n    cursor: pointer;\n    font-weight: bold;\n    color: #2c3e50;\n}\n\nsummary:hover {\n    color: #3498db;\n}\n\n.game {\n    background: white;\n    padding: 20px;\n    border-radius: 12px;\n    margin-bottom: 20px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    width: 50%;\n    justify-self: center;\n}\n\n.game-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.game-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.game-info p {\n    margin: 4px 0;\n}\n\n.join-btn {\n    background-color: #2ecc71;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: background-color 0.2s;\n\n}\n\n.join-btn:hover {\n    background-color: #27ae60;\n}\n\n.createGameButton {\n    display: block;\n\n    margin: 20px auto;\n    padding: 12px 24px;\n\n    background-color: #4CAF50;\n    color: white;\n\n    border: none;\n    border-radius: 8px;\n\n    font-size: 18px;\n    font-weight: bold;\n\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n.anagramsCGB {\n    background-color: #1A78A3;\n}\n.anagramsCGB:hover {\n    background-color: #16698e;\n}\n    \n.connfourCGB {\n    background-color: #526236;\n}\n\n.connfourCGB:hover {\n    background-color: #227a16;\n}\n\n.createGameButton:hover {\n\n    transform: translateY(-2px);\n}\n\n.createGameButton:active {\n    transform: translateY(0);\n}\n\n/* Responsive */\n\n@media (max-width: 768px) {\n    .Title h1 {\n        font-size: 2rem;\n    }\n\n    .game {\n        padding: 15px;\n    }\n};\n\n\n\n.createGameButton:active {\n    transform: translateY(0);\n}\n\n/* Responsive */\n\n@media (max-width: 768px) {\n    .Title h1 {\n        font-size: 2rem;\n    }\n\n    .game {\n        padding: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
